module.exports = __webpack_public_path__ + "static/fonts/NanumSquareL.f2a56a3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareL.ttf
// module id = LI90
// module chunks = 1